// src/components/pengguna/SectionKelola.jsx
import React, { useState } from "react";
import { FaPlus, FaTrash, FaPen } from "react-icons/fa";

const SectionKelola = ({ title, data, onAdd, onDelete, onEdit }) => {
  const [newValue, setNewValue] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [editValue, setEditValue] = useState("");

  const handleSaveEdit = () => {
    const trimmed = editValue.trim();
    if (!trimmed) return;

    const exists = data.some(
      (item, idx) => item.label === trimmed && idx !== editIndex
    );
    if (exists) return;

    const updated = [...data];
    updated[editIndex] = { ...updated[editIndex], label: trimmed };
    onEdit(updated);
    setEditIndex(null);
    setEditValue("");
  };

  const handleAdd = () => {
    const trimmed = newValue.trim();
    if (
      !trimmed ||
      data.some((item) => item.label.toLowerCase() === trimmed.toLowerCase())
    )
      return;
    onAdd(trimmed); // kamu yang handle jadi { id, label }
    setNewValue("");
  };

  return (
    <div className="p-4 bg-white border rounded-lg shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-green-800">{title}</h2>

      <div className="flex items-center gap-2 mb-4">
        <input
          type="text"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          placeholder={`Tambah ${title.toLowerCase()}...`}
          className="flex-grow px-3 py-2 text-sm border border-green-300 rounded focus:outline-none focus:ring-2 focus:ring-green-500"
        />
        <button
          onClick={handleAdd}
          className="p-2 text-white bg-green-600 rounded hover:bg-green-700"
          title="Tambah"
        >
          <FaPlus size={14} />
        </button>
      </div>

      <ul className="space-y-2 text-sm">
        {data.length === 0 && (
          <li className="italic text-gray-400">Belum ada data</li>
        )}
        {data.map((item, index) => (
          <li
            key={item.id}
            className="flex items-center justify-between px-3 py-2 border border-green-100 rounded bg-gray-50"
          >
            {editIndex === index ? (
              <input
                type="text"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={handleSaveEdit}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSaveEdit();
                  if (e.key === "Escape") setEditIndex(null);
                }}
                className="flex-grow px-2 py-1 mr-2 text-sm border border-green-300 rounded"
                autoFocus
              />
            ) : (
              <span>{item.label}</span>
            )}
            <div className="flex items-center gap-2">
              <button
                onClick={() => {
                  setEditIndex(index);
                  setEditValue(item.label);
                }}
                className="p-1 text-white bg-yellow-500 rounded hover:bg-yellow-600"
              >
                <FaPen size={12} />
              </button>
              <button
                onClick={() => onDelete(item)}
                className="p-1 text-white bg-red-500 rounded hover:bg-red-600"
              >
                <FaTrash size={12} />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SectionKelola;
